export default {
    payment: {},
    paymentList: [],
    mainPaymentList: []
}